import type { VerificationProfileSettingsModel } from '@models';
import {
    DocsVerificationBiometricTypeEnum,
    DocsVerificationDocumentTypeEnum,
    VerificationPhotosKeysEnum,
} from '@models/enums';
import type { GetVerificationResponse } from '@modules/docs-verification-widget/api/get-verification-response';
import dayjs from 'dayjs';

export const VERIFICATION_RESPONSE: GetVerificationResponse = {
    id: 'VD485833FBBBFEFCA',
    status: 'active',
    checks: {
        poa: {
            status: 'pending',
            errors: [],
            pending_documents: [VerificationPhotosKeysEnum.POA],
            data: null,
        },
        liveness: {
            status: 'pending',
            errors: [],
            pending_documents: [VerificationPhotosKeysEnum.LIVENESS_PHOTO],
            data: null,
        },
        document_mrz: {
            status: 'pending',
            errors: [],
            pending_documents: [
                VerificationPhotosKeysEnum.RESIDENCE_PERMIT_FRONT,
                VerificationPhotosKeysEnum.RESIDENCE_PERMIT_BACK,
                VerificationPhotosKeysEnum.ID_CARD_BACK,
                VerificationPhotosKeysEnum.PASSPORT,
                VerificationPhotosKeysEnum.ID_CARD_FRONT,
            ],
            data: null,
        },
        face_comparison: {
            status: 'pending',
            errors: [],
            pending_documents: [
                VerificationPhotosKeysEnum.SELFIE,
                VerificationPhotosKeysEnum.RESIDENCE_PERMIT_FRONT,
                VerificationPhotosKeysEnum.PASSPORT,
                VerificationPhotosKeysEnum.LIVENESS_PHOTO,
                VerificationPhotosKeysEnum.ID_CARD_FRONT,
            ],
            data: null,
        },
    },
    settings: {
        poi_required: true,
        poi_allowed_documents: [
            DocsVerificationDocumentTypeEnum.PASSPORT,
            DocsVerificationDocumentTypeEnum.ID_CARD,
            DocsVerificationDocumentTypeEnum.RESIDENCE_PERMIT,
        ],
        face_comparison_required: true,
        face_comparison_allowed_documents: [DocsVerificationBiometricTypeEnum.LIVENESS_PHOTO],
        poa_required: true,
        poa_allowed_documents: [],
        countries: [],
        allow_poi_manual_uploads: true,
        allow_desktop: true,
    } as unknown as VerificationProfileSettingsModel,
    expires_at: dayjs().add(360, 'minutes').toDate().toString(),
    verification_url: 'https://am.dataspike.io/VD485833FBBBFEFCA',
};
